import { render, staticRenderFns } from "./UiPostPreview.vue?vue&type=template&id=2ee838c4&"
import script from "./UiPostPreview.vue?vue&type=script&lang=js&"
export * from "./UiPostPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports